<template>
  <div>
    <md-toolbar md-elevation="0" class="md-transparent">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">{{ this.getHeader }}</h3>
        </div>
        <!-- <md-switch v-model="isLive">{{ isLive ? "Live" : "Test" }}</md-switch> -->
        <div class="md-toolbar-section-end">
          <md-list>
            <li class="md-list-item">
              <div class="md-list-item-content">
                <drop-down>
                  <md-button
                    slot="title"
                    class="md-simple"
                    data-toggle="dropdown"
                  >
                    <span>{{ $store.state.userData.name }}</span>
                    <md-icon>person</md-icon>
                  </md-button>
                  <ul class="dropdown-menu dropdown-menu-right">
                    <li @click="$router.push('/profile')"><a>My Profile</a></li>
                    <li @click="$router.push('/profile/businesses')">
                      <a>Businesses</a>
                    </li>
                    <li @click="logout"><a>Logout</a></li>
                  </ul>
                </drop-down>
              </div>
            </li>
          </md-list>
        </div>
        <!-- <md-toolbar md-elevation="0" class="md-transparent">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">{{ this.getHeader }}</h3>
        </div>
        <div class="md-toolbar-section-end">No</div>
      </div>
    </md-toolbar> -->

        <!-- Hamburger Icon -->
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span><span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
        <!-- Mobile Responsiveness -->
        <!-- <div class="md-toolbar-section-end">
          <md-menu>
            <md-icon md-menu-trigger :md-offset-y="-80">person</md-icon>

            <md-menu-content>
              <md-menu-item @click="$router.push('/profile')">
                Profile
              </md-menu-item>

              <md-menu-item @click="$router.push('/profile/businesses')">
                Businesses
              </md-menu-item>
              <md-menu-item @click="logout"> Logout </md-menu-item>
            </md-menu-content>
          </md-menu>
          <md-button
            class="md-just-icon md-icon-button md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span><span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>
        </div> -->
      </div>
    </md-toolbar>

    <!-- <md-toolbar md-elevation="0" class="md-transparent">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">{{ $route.name }}</h3>
        </div>
        <div class="md-toolbar-section-end">
          <md-button
            class="md-just-icon md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span><span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

          <div>
            <md-list>
              <li class="md-list-item">
                <div class="md-list-item-content">
                  <drop-down>
                    <md-button
                      slot="title"
                      class="md-simple"
                      data-toggle="dropdown"
                    >
                      <span>{{ $store.state.userData.name }}</span>
                      <md-icon>person</md-icon>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li @click="$router.push('/profile')">
                        <a>My Profile</a>
                      </li>
                      <li @click="$router.push('/profile/businesses')">
                        <a>Businesses</a>
                      </li>
                      <li @click="logout"><a>Logout</a></li>
                    </ul>
                  </drop-down>
                </div>
              </li>
            </md-list>
          </div>
        </div>
      </div>
    </md-toolbar> -->
  </div>
</template>

<script>
import Token from '../../utils/Token.util';

export default {
  computed: {
    getHeader() {
      if (this.$route.path.includes('settings')) {
        return 'Settings';
      }
      return this.$route.meta.label;
    },
  },
  watch: {
    isLive(value) {
      this.$store.commit('setIsLive', value);
    },
  },
  data() {
    return {
      isLive: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    logout() {
      Token.unsetToken();
      this.$router.replace('/signin');
      this.$store.commit('resetState');
    },
  },
};
</script>

<style scoped>
.md-icon-button {
  background-color: transparent !important;
}
/* .md-switch-thumb::before {
  background-color: #ff5252 ;
  background-color: var(--md-theme-default-accent, #ff5252);
} */
</style>
